import { render } from "./Inventory_Transfers_Dialog.vue?vue&type=template&id=7ef4e032&scoped=true"
import script from "./Inventory_Transfers_Dialog.vue?vue&type=script&lang=js"
export * from "./Inventory_Transfers_Dialog.vue?vue&type=script&lang=js"

import "./Inventory_Transfers_Dialog.vue?vue&type=style&index=0&id=7ef4e032&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef4e032"]])

export default __exports__